import { createFileRoute } from '@tanstack/react-router'
import { requirePagePermission } from '~/features/org/guard'
import { MembersPage } from '~/features/org/MembersPage'
import { membersQuery } from '~/features/org/queries'

export const Route = createFileRoute('/_app/verein/mitglieder/')({
  beforeLoad: ({ context }) => requirePagePermission(context.queryClient, 'members.manage'),
  loader: ({ context }) => context.queryClient.ensureQueryData(membersQuery),
  component: MembersPage,
})
